module.exports = __webpack_public_path__ + "media/newstyle/images/X-a1105595869177bd3d67c348ca006399.png";